import { lazy, Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { PdpSharedRingSizeGuideModalLazy } from '../shared/PdpSharedDetail/PdpSharedRingSizeGuideModalLazy';
import { Link } from 'dibs-elements/exports/Link';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from './styles/pdpRespSwatchSelector.scss';

const SwatchSelector = lazy(() =>
    import(/* webpackChunkname: "swatchSelectorMain "*/ './SwatchSelectorMain')
);

const messages = defineMessages({
    sizeGuide: {
        id: 'pdp.respSwatchSelectorRingSizeGuide',
        defaultMessage: 'Size Guide',
    },
});

const PdpRespSwatchSelectorComponent = props => {
    const {
        currency,
        onClick,
        isClient,
        item,
        user,
        relay,
        selectedSkuId,
        showSwatchDescriptionOnHover,
    } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const intl = useIntl();

    return (
        <Suspense fallback={''}>
            <SwatchSelector
                currency={currency}
                selectedSkuId={selectedSkuId}
                item={item}
                userIsTrade={user && !!user.isVerifiedTrade}
                transactions={null}
                onClick={onClick}
                relay={relay}
                pageLayout="PDP"
                showSwatchDescriptionOnHover={showSwatchDescriptionOnHover}
            />
            {item?.isRingItem ? (
                <>
                    <Link className={styles.sizeGuideLink} onClick={() => setModalOpen(true)}>
                        {intl.formatMessage(messages.sizeGuide)}
                    </Link>
                    {isClient && (
                        <PdpSharedRingSizeGuideModalLazy
                            isOpen={modalOpen}
                            onClose={() => setModalOpen(false)}
                            relay={relay}
                        />
                    )}
                </>
            ) : null}
        </Suspense>
    );
};

PdpRespSwatchSelectorComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    isClient: PropTypes.bool,
    currency: PropTypes.string,
    onSwatchClick: PropTypes.func,
    selectedSkuId: PropTypes.string,
    onClick: PropTypes.func,
    showSwatchDescriptionOnHover: PropTypes.bool,

    // relay response data
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
};
export const PdpRespSwatchSelector = createFragmentContainer(PdpRespSwatchSelectorComponent, {
    item: graphql`
        fragment PdpRespSwatchSelector_item on Item {
            ...SwatchSelector_item @arguments(shouldFetchBuyerInfo: true)
            isRingItem
        }
    `,
    user: graphql`
        fragment PdpRespSwatchSelector_user on User {
            isVerifiedTrade
        }
    `,
});
